import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import CustomCircleLoader from './CustomCircleLoader';
import s from './Loader.css';

const ButtonLoader = ({
  label = 'Submit',
  type = 'button',
  show = false,
  handleClick,
  className,
  disabled,
  spinnerColor = '#fff',
  image,
  tickIcon,
  tickIconStyle
}) => {
  const isDisabled = show || disabled;

  return (
    <Button
      className={className}
      disabled={isDisabled}
      type={type}
      onClick={handleClick}
    >
      {show && (
        <CustomCircleLoader size={18} singleColor={spinnerColor} borderSize={3} />
      )}
      {tickIcon && <img src={tickIcon} className={tickIconStyle} />}
      {label}
      {image && <img src={image} className='loginArrowRTL' />}
    </Button>
  );
};

ButtonLoader.propTypes = {
  label: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  handleClick: PropTypes.any,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  spinnerColor: PropTypes.string,
  image: PropTypes.string,
  tickIcon: PropTypes.string,
  tickIconStyle: PropTypes.string
};

ButtonLoader.defaultProps = {
  label: 'Submit',
  show: false,
  type: 'button',
  spinnerColor: '#fff'
};

export default withStyles(s)(ButtonLoader);
